import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';

const INITIAL_STATE = fromJS({
  person: fromJS({}),
  fetching: false,
  posting: false,
  updating: false,
  message: '',
  isPasswordModalOpen: false,
  resettingPassword: false,
  resetPasswordMessage: '',
  deleting: false
});

function createPerson(state, action) {
  return state
    .set('posting', true)
}

function createPersonSuccess(state, action) {
  return state
    .set('posting', false)
    .set('message', 'Person was created successfully')
}

function createPersonFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to create Person'
  }
  return state
    .set('posting', false)
    .set('message', msg)
}

function getPersonById(state, action) {
  return state
    .set('fetching', true)
}

function getPersonByIdSuccess(state, action) {
  return state
    .set('fetching', false)
    .set('person', fromJS(action.payload.body))
}

function getPersonByIdFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to load person'
  }
  return state
    .set('fetching', false)
    .set('message', msg)
}

function updatePerson(state, action) {
  return state
    .set('updating', true)
}

function updatePersonSuccess(state, action) {
  return state
    .set('updating', false)
}

function updatePersonFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to update person'
  }
  return state
    .set('updating', false)
    .set('message', msg)
}

function changePersonState(state, action) {
  return state
    .set(action.payload.key, action.payload.value)
}

function resetState(state, action) {
  return INITIAL_STATE;
}

function resetPassword(state, action) {
  return state
    .set('resettingPassword', true)
}

function resetPasswordSuccess(state, action) {
  return state
    .set('resettingPassword', false)
    .set('isPasswordModalOpen', false)
    .set('resetPasswordMessage', 'Password changed')
}

function resetPasswordFailed(state, action) {
  return state
    .set('resettingPassword', false)
    .set('resetPasswordMessage', 'Failed to change password')
}

function deletePerson(state, action) {
  return state
    .set('deleting', true)
}

function deletePersonSuccess(state, action) {
  return state
    .set('deleting', false)
    .set('message', 'Person deleted successfully')
}

function deletePersonFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to delete person'
  }
  return state
    .set('deleting', false)
    .set('message', msg)
}

export const person = createReducer(INITIAL_STATE, {
  [ActionTypes.CREATE_PERSON]: createPerson,
  [ActionTypes.CREATE_PERSON_SUCCESS]: createPersonSuccess,
  [ActionTypes.CREATE_PERSON_FAIL]: createPersonFailed,
  [ActionTypes.GET_PERSON_BY_ID]: getPersonById,
  [ActionTypes.GET_PERSON_BY_ID_SUCCESS]: getPersonByIdSuccess,
  [ActionTypes.UPDATE_PERSON]: updatePerson,
  [ActionTypes.UPDATE_PERSON_SUCCESS]: updatePersonSuccess,
  [ActionTypes.UPDATE_PERSON_FAILED]: updatePersonFailed,
  [ActionTypes.CHANGE_PERSON_STATE]: changePersonState,
  '@@router/LOCATION_CHANGE': resetState,
  [ActionTypes.RESET_PASSWORD]: resetPassword,
  [ActionTypes.RESET_PASSWORD_SUCCESS]: resetPasswordSuccess,
  [ActionTypes.RESET_PASSWORD_FAILED]: resetPasswordFailed,
  [ActionTypes.DELETE_PERSON]: deletePerson,
  [ActionTypes.DELETE_PERSON_SUCCESS]: deletePersonSuccess,
  [ActionTypes.DELETE_PERSON_FAILED]: deletePersonFailed,
});



// WEBPACK FOOTER //
// ./src/reducers/person.js